import { ContentBlockType, GojsDiagramBlock } from '../../../model';

export const GOJS_DIAGRAM_NODE_NAME = 'gojsDiagram';

export const DEFAULT_GOJS_DIAGRAM_PROPS: Omit<GojsDiagramBlock, 'id'> = {
  type: ContentBlockType.GojsDiagram,
  model: {
    nodes: [{ key: '1', text: 'Node 1' }],
    links: [],
  },
  layout_type: 'tree',
  height: 300,
};
